module.exports = __webpack_public_path__ + "assets/img/chartCard-hash.0d6b1d3b.svg";